import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { Wrapper, SpanWrapper } from './wrappers';
import { FlexBoxWrapper, GenericWrapper, Mr2 } from 'wrappers';
import internalState from './internalState';
import { SolidButton, Rating } from 'molecules';
import { ProfileImage, Initials, SecondaryTextSm } from 'atoms';
import { Stats } from './molecules';
import { getInitials } from 'utils/getInitials';

export const definition = {
  name: 'AssignWorkerRow',
  controller: Controller,
  initialProps: ({ image, name, assignments, completion_time, rating, id, assignedId, displayButton, role }) => ({ image, name, assignments, completion_time, rating, id, assignedId, displayButton, role }),
  props: internalState,
  elements: [
    {
      wrapper: Wrapper,
      name: 'Wrapper',
      isButton: true,
      bindings: ({ displayButton, id, assignedId, image, name }) => ({ displayButton, id, assignedId, image, name }),
      elements: [
        {
          wrapper: FlexBoxWrapper,
          name: 'Info',
          elements: [
            {
              component: wrap(Initials, Mr2),
              name: 'Initials',
              renderIf: ({ image }) => !image,
              displayValue: ({ name }) => getInitials(name)?.slice(0, 2) ?? '',
              displayState: ({ }) => ({ size: 40 })
            },
            {
              component: wrap(ProfileImage, Mr2),
              name: 'Image',
              renderIf: ({ image }) => image,
              displayValue: ({ image }) => image,
              displayState: ({ }) => ({ size: 40 })
            },
            {
              wrapper: GenericWrapper,
              name: 'Info',
              elements: [
                {
                  component: SecondaryTextSm,
                  name: 'Name',
                  displayValue: ({ name }) => name || ''
                },
                {
                  component: Stats,
                  name: 'Stats',
                  renderIf: ({ role }) => !role,
                  bindings: ({ assignments, completion_time }) => ({ assignments, completion_time })
                },
                {
                  component: Rating,
                  name: 'Rating',
                  renderIf: ({ role }) => !role,
                  bindings: ({ rating }) => ({ rating })
                }
              ]
            }
          ]
        },
        {
          component: wrap(SolidButton, SpanWrapper),
          name: 'AssignButton',
          renderIf: ({ displayButton }) => displayButton,
          displayValue: () => null,
          bindings: ({ id, assignedId, image, name }) => {
            let title = 'Assign';
            if (!!assignedId) {
              title = 'Reassign'
            }
            if (assignedId === id) {
              title = 'Unassign'
            }
            return { id, assignedId, title, image, name }
          }
        }
      ]
    }
  ]
}

export default ContainerComponent(definition);